module.exports = __webpack_public_path__ + "static/img/live_manage.18407099.png";